import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tmods_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const hadToken = !!localStorage.getItem('tmods_token');
      localStorage.removeItem('tmods_token');
      localStorage.removeItem('user');
      if (hadToken) window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

export const auth = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
  setAvatar: (avatar) => api.post('/auth/avatar', { avatar }),
};

export const content = {
  modules: () => api.get('/modules'),
  module: (id) => api.get(`/module/${id}`),
  courses: (moduleId) => api.get(`/module/${moduleId}/courses`),
  course: (moduleId, courseId) => api.get(`/module/${moduleId}/course/${courseId}`),
  lessons: (moduleId, courseId) => api.get(`/module/${moduleId}/course/${courseId}/lessons`),
  lesson: (moduleId, courseId, lessonId) =>
    api.get(`/module/${moduleId}/course/${courseId}/lesson/${lessonId}`),
  quiz: (moduleId, courseId) => api.get(`/module/${moduleId}/course/${courseId}/quiz`),
};

export const progress = {
  list: () => api.get('/progress'),
  update: (data) => api.post('/progress', data),
  quiz: (data) => api.post('/quiz-progress', data),
};

export const execute = {
  r: (code) => api.post('/execute/r', { code }),
};
